import '../App.css';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom'
import Axios from 'axios';
import React, {useEffect, useState} from 'react';
import queryString from "query-string"

function Bodyresetpass(props)
{
    const navigate = useNavigate();
    const queryParams = queryString.parse(window.location.search)
    const[seccionmensaje, setSeccionMensaje] = useState('seccionNoVisible')
    const[seccionvalidacion, setSeccionValidacion] = useState('seccionNoVisible')
    const[seccionvalidacion2, setSeccionValidacion2] = useState('seccionNoVisible')
    const[seccionvalidacion3, setSeccionValidacion3] = useState('seccionNoVisible')
    const[seccionreset, setSeccionReset] = useState()
    const[recoverCode, setRecoverCode] = useState()
    const[password, setPassword] = useState('')
    const[password2, setPassword2] = useState('')
    let statuscall = '' 

    const clickReestablecer = async (e) => {
        if (password != '')
        {
            if(password2 != '')
            {
                if(password == password2)
                {
                    const data = {   
                        password: password
                    }
                    const recuperarPass = await Axios.put(process.env.REACT_APP_URLRESETPASS+recoverCode, data, {
                        headers: {
                            'Access-Control-Allow-Origin' : '*',
                            'Access-Control-Allow-Methods': 'GET, POST',
                            'Access-Control-Allow-Headers': 'Content-Type'
                        }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                        
                        if(statuscall.status == 200)
                        {
                            setSeccionValidacion('seccionNoVisible')
                            setSeccionValidacion2('seccionNoVisible')
                            setSeccionValidacion3('seccionNoVisible')
                            setSeccionReset('seccionNoVisible')
                            setSeccionMensaje('seccionVisible')
                        }
                }
                else
                {
                    setSeccionValidacion3('seccionVisible')
                }
            }
            else
            {
                setSeccionValidacion2('seccionVisible')
            }
        }
        else
        {
            setSeccionValidacion('seccionVisible')
        }

    }

    const handlerPassword = (e) =>{
        setSeccionValidacion('seccionNoVisible')
        setSeccionValidacion2('seccionNoVisible')
        setSeccionValidacion3('seccionNoVisible')
        setPassword(e.target.value)
    }

    const handlerPassword2 = (e) =>{
        setSeccionValidacion('seccionNoVisible')
        setSeccionValidacion2('seccionNoVisible')
        setSeccionValidacion3('seccionNoVisible')        
        setPassword2(e.target.value)
    }

    useEffect(() => {
        let recovercode = JSON.stringify(queryParams.recovercode).replace('"', '')
        if(recovercode == 'null')
        {
            navigate('/')
        }
        else
        {
            Axios.get(process.env.REACT_APP_URLVALIDATERECOVERCODE, {
                params:{
                    recovercode: recovercode.replace('"', "")
                },
                headers: {
                    'Access-Control-Allow-Origin' : '*',
                    'Access-Control-Allow-Methods': 'GET, POST',
                    'Access-Control-Allow-Headers': 'Content-Type'
                }}).then(res => setRecoverCode(recovercode.replace('"', ''))).catch(err => navigate('/') );
                
                /*if(statuscall.status != 200)
                {
                    console.log(statuscall.status)
                       
                }*/
        }
    },[])


    return (
        <div className='sshbodyappContainerLogin'>
            <div className='sshbodyappContainerLoginCarrusel'>

            </div>
            <div className='sshbodyappContainerLoginForm'>
                <div className='container'>
                    <div className={seccionreset}>
                        <div className='row'>
                            <div className='col col-lg-5'></div>
                            <div className='col col-lg-2'>
                                <h1>Reestablecer Contraseña</h1>
                            </div>
                            <div className='col col-lg-5'></div>
                        </div>
                        <div className='row'>
                            <div className='col col-lg-4'>
                            </div>
                            <div className='col col-lg-4'>
                                <Form.Control type="password" onChange={handlerPassword} placeholder="***********"/>
                            </div>                                                                                    
                            <div className='col col-lg-4'>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col col-lg-4'>
                            </div>
                            <div className='col col-lg-4'>
                                <Form.Control type="password" onChange={handlerPassword2} placeholder="***********"/>
                            </div>                                                                                    
                            <div className='col col-lg-4'>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col col-lg-4'></div>
                            <div className='col col-lg-4'>
                                <div className="d-grid gap-2">
                                    <Button onClick={clickReestablecer} variant="primary"  size="lg">
                                        Recuperar
                                    </Button>
                                </div>
                            </div>
                            <div className='col col-lg-4'></div>
                        </div>
                    </div>

                    <div className={seccionmensaje}>
                        <div className='row'>
                            <div className='col col-lg-2'></div>
                            <div className='col col-lg-8'>
                                <h5>Su contraseña se ha reestablecido
                                    con exito. Inicie sesion en el sistema,
                                    ingresando su usuario y su nueva password. 
                                </h5>
                                <Link to={`/`}>Iniciar Sesion</Link>
                            </div>
                            <div className='col col-lg-2'></div>                            
                        </div>
                    </div>

                    <div className={seccionvalidacion}>
                        <div className='row'>
                            <div className='col col-lg-2'></div>
                            <div className='col col-lg-8'>
                                <h5>Debe ingresar una contraseña</h5>
                            </div>
                            <div className='col col-lg-2'></div>                            
                        </div>
                    </div>

                    <div className={seccionvalidacion2}>
                        <div className='row'>
                            <div className='col col-lg-2'></div>
                            <div className='col col-lg-8'>
                                <h5>Debe ingresar contraseña en ambos campos</h5>
                                
                            </div>
                            <div className='col col-lg-2'></div>                            
                        </div>
                    </div>

                    <div className={seccionvalidacion3}>
                        <div className='row'>
                            <div className='col col-lg-2'></div>
                            <div className='col col-lg-8'>
                                <h5>Las contraseñas con concuerdan</h5>
                            </div>
                            <div className='col col-lg-2'></div>                            
                        </div>
                    </div>                                                                                            
                </div>
            </div>
        </div>            
    )    
}
export default Bodyresetpass